module.exports = __webpack_public_path__ + "static/img/logo_ufes.d06dd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ufes.png
// module id = 237
// module chunks = 0